/* eslint-disable tss-unused-classes/unused-classes */
import { makeStyles } from 'tss-react/mui';
import { SizingOptions } from '../Awards/types';

export const useCertificationLogoStyles = makeStyles<{
  size: SizingOptions;
}>()((_, { size }) => ({
  container: {
    border: '1px solid rgb(224, 224, 224)',
    borderRadius: 4,
    backgroundColor: 'rgb(250, 250, 250)',
    position: 'relative',
    color: 'rgb(67, 67, 67)',
    padding: size === 'sm' ? 4 : 6
  },
  image: {
    aspectRatio: '1 / 1',
    objectFit: 'contain',
    height: size === 'sm' ? 25 : 30
  }
}));
